import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Provider } from 'src/app/models/signatureProvider';
import { map, Observable, shareReplay } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SignatureProviderTypeEnum } from 'src/app/constants/signature-provider-type.enum';
import { AuthenticationService } from '../authentication.service';
import { LocalStorageService } from '../local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class EngineApiClient {
  private ENGINE_ENDPOINT = environment.signingApiUrl;
  private cache!: Observable<Provider[]>;
  readonly nameForESeal: string = this.translateService.instant('NameOfEseal');


  constructor(private http: HttpClient, private localStorageService: LocalStorageService, private translateService: TranslateService, private authenticationService: AuthenticationService) { }


  /**
   * Return the stamp
   * @param stampWidth width of the stamp. by default 600px
   * @param stampHeight height of the stamp. by default 200px
   * @param justText given only the stamp as it should or only the text for scribble/image. by default false
   * @returns Blob
   */
  getStamp(stampWidth: number = 600, stampHeight: number = 200, justText: boolean = false) {
    let utcOffset = (new Date()).getTimezoneOffset() * -1;
    let language = this.localStorageService.Language;
    let bodyObject = {
      width: stampWidth,
      height: stampHeight,
      language: language,
      utcOffsetMinutes: utcOffset
    };
    if (justText) {
      return this.http.post(this.ENGINE_ENDPOINT + "/api/signing/stamptext", bodyObject, { responseType: 'blob' });
    } else {
      return this.http.post(this.ENGINE_ENDPOINT + "/api/signing/stamp", bodyObject, { responseType: 'blob' });
    }
  }

  getSignatureProviders() {
    if (!this.cache) {
      this.cache = this.http.get<Provider[]>(this.ENGINE_ENDPOINT + "/api/signing/providers", {}).pipe(
        map(data => {
          data.forEach((provider: Provider) => {
            if (provider.signatureProviderType.includes(SignatureProviderTypeEnum.Eseal)) {
              provider.name = this.nameForESeal + (provider.testProfile ? " (" + this.translateService.instant('Request.View.SigningDialog.Test') + ")" : "");
            } else {
              provider.name = provider.name + (provider.testProfile ? " (" + this.translateService.instant('Request.View.SigningDialog.Test') + ")" : "")
            }
          })
          if (!this.authenticationService.currentUserValue.isSystemAdmin) {
            data = data.filter(s => !s.testProfile);
          }
          return data;
        }),
        shareReplay(1)
      );
    }
    return this.cache;
  }
}